import React, { useState } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import AddItemPopup from './AddItemPopup.js'
import './App.css'

const FieldType_WatchlistAlerts = ({ value, row, globalContext }) => {
    const [isWorking, setIsWorking] = useState(false);
    const enabled = value === true || value === "true" || value === 1 || value === "On" || !!row?.AlertsEnabled;

    const toggleAlerts = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!row?.Id || isWorking)
            return;

        const nextEnabled = !enabled;
        setIsWorking(true);

        // Optimistic list update
        if (globalContext?.setData && Array.isArray(globalContext.data)) {
            globalContext.setData(
                globalContext.data.map((item) =>
                    item.Id === row.Id
                        ? {
                            ...item,
                            AlertsEnabled: nextEnabled,
                            AlertsEnabledDisplay: nextEnabled ? "On" : "Off",
                        }
                        : item
                )
            );
        }

        const formData = new FormData();
        formData.append("workspaceId", row.Id);
        formData.append("enabled", nextEnabled ? "true" : "false");

        fetch("/umbraco/api/WatchlistsApi/WatchlistAlertsEnabled", { method: "POST", body: formData })
            .then(async (response) => {
                if (!response.ok)
                    throw new Error(await response.text() || "Could not update alerts");
                return response.json();
            })
            .then((result) => {
                const nextValue = typeof result?.AlertsEnabled === "boolean" ? result.AlertsEnabled : nextEnabled;
                if (globalContext?.setData && Array.isArray(globalContext.data)) {
                    globalContext.setData(
                        globalContext.data.map((item) =>
                            item.Id === row.Id
                                ? {
                                    ...item,
                                    AlertsEnabled: nextValue,
                                    AlertsEnabledDisplay: nextValue ? "On" : "Off",
                                }
                                : item
                        )
                    );
                }
            })
            .catch(() => {
                // Revert optimistic update
                if (globalContext?.setData && Array.isArray(globalContext.data)) {
                    globalContext.setData(
                        globalContext.data.map((item) =>
                            item.Id === row.Id
                                ? {
                                    ...item,
                                    AlertsEnabled: enabled,
                                    AlertsEnabledDisplay: enabled ? "On" : "Off",
                                }
                                : item
                        )
                    );
                }
            })
            .finally(() => setIsWorking(false));
    };

    if (isWorking) {
        return (
            <span className="watchlists-list-alerts-icon" data-no-row-click="true">
                <LoadingSpinnerImage small={true} />
            </span>
        );
    }

    return (
        <button
            type="button"
            className={`watchlists-list-alerts-icon ${enabled ? "enabled" : "disabled"}`}
            title={enabled ? "Click to disable alerts" : "Click to enable alerts"}
            onClick={toggleAlerts}
            data-no-row-click="true"
        >
            <i className={enabled ? "fas fa-bell" : "fas fa-bell-slash"} />
        </button>
    );
};

const Watchlists = () => {

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/WatchlistsApi/Watchlists";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/WatchlistsApi/Watchlist";
    dataTableStructure.pageTitle = "Watchlists";
    dataTableStructure.singleItemTitle = "Watchlist";
    dataTableStructure.entityType = "watchlist";
    dataTableStructure.pageIcon = "fas fa-binoculars";
    dataTableStructure.breadcrumbs = [{ "Name": "Watchlists", "Link": "/your-medboard/lists-monitoring/" }];
    dataTableStructure.dataStructure = [];
    dataTableStructure.deleteUrl = "/umbraco/api/WatchlistsApi/BulkWatchlists/?ids=";
    dataTableStructure.showDeleteButton = true;
    dataTableStructure.preLoadItemUrlParamName = "Id";
    dataTableStructure.preLoadItemId = window.preloadWatchlistId;
    dataTableStructure.showListTotalCount = true;
    dataTableStructure.listTotalCountURL = "/umbraco/api/WatchlistsApi/WatchlistsCount/";

    dataTableStructure.dataStructure.push({ name: "Name", field: "Name", width: "20%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Description", field: "Description", width: "20%", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Profile Types", field: "ProfileTypesDisplay", width: "14%", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Items", field: "ItemsCount", width: "7%", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Notes", field: "NotesCount", width: "7%", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Alerts", field: "AlertsEnabled", width: "8%", sortable: false, renderWith: FieldType_WatchlistAlerts });
    dataTableStructure.dataStructure.push({ name: "Created By", field: "CreatedByName", width: "12%", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Updated", field: "LastUpdate", width: "12%", sortable: true, renderWith: FieldTypes.FieldType_DateList });

    dataTableStructure.dataUrlParameters = { search: null, page: 1, sortBy: "CreatedOn", sortType: "DESCENDING" };

    return (
        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} AddItemPopup={AddItemPopup} />
    );
};

export default Watchlists;
